<template>
    <img :src="mnbg" alt="Imagen de fondo" style="position: fixed;top: 0;left: 0;width: 100%;height: 100%;object-fit: cover;opacity: 0.05;z-index: -1;">
        <div class="container-fluid" style="margin-top: 110px">
            <div class="row">
                <!-- <div class="col-12">
                    <h2 class="text-center title-sm epilogue-semibold"> 
                        BLOG
                    </h2>
                </div> -->
    			<div class="col-12 col-md-6" v-for="(card, index) in cards" :key="index" data-aos="flip-left">
                    <div class="d-flex justify-content-center carousel-slide mb-3 ">
                        <div class="mx-3 p-2 border-bottom border-3 blog_border">
                            <img :src="card.image" alt="Marcas Productos" loading="lazy"
                            class="img-fluid" style="object-fit: cover; object-position: center;"/>
                            <p class="text-start description-xxs epilogue-regular">{{ card.date }}</p>
                            <p class="text-start description-xs epilogue-semibold">{{ card.text }}</p>
                            <p class="text-start description-xxs epilogue-regular">{{ card.text2 }}</p>
                            <p class="text-start description-xxs epilogue-regular">Leer más</p>
                        </div>
                        
                    </div>
				</div>
            </div>
        </div>
</template>

<script setup>

	import magdamn from "ASSETS/images/37"
	import magdamn1 from "ASSETS/images/38"
	import magdamn2 from "ASSETS/images/39"
	import magdamn3 from "ASSETS/images/40"
	import magdamn4 from "ASSETS/images/37"

    import mnbg from "ASSETS/images/vectormn"

	const cards = [
		{ image: magdamn, text: "Entrada de blog 01", text2: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsum quia cumque consequuntur, ducimus illum animi rem fugit? Voluptatum, aspernatur", date: "September 10, 2021" },
		{ image: magdamn1, text: "Entrada de blog 01", text2: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsum quia cumque consequuntur, ducimus illum animi rem fugit? Voluptatum, aspernatur", date: "September 10, 2021" },
		{ image: magdamn2, text: "Entrada de blog 01", text2: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsum quia cumque consequuntur, ducimus illum animi rem fugit? Voluptatum, aspernatur", date: "September 10, 2021" },
		{ image: magdamn3, text: "Entrada de blog 01", text2: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsum quia cumque consequuntur, ducimus illum animi rem fugit? Voluptatum, aspernatur", date: "September 10, 2021" },
		{ image: magdamn4, text: "Entrada de blog 01", text2: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Ipsum quia cumque consequuntur, ducimus illum animi rem fugit? Voluptatum, aspernatur", date: "September 10, 2021" }
	]

</script>



<style lang="scss" scoped>

</style>
